import * as AriaKit from '@ariakit/react';
import styled from 'styled-components';
import { zIndexForeground } from '../../constants';
export const Menu = styled(AriaKit.Menu) `
  margin-top: 10px;
  padding: ${o => o.theme.spacing(2)};
  opacity: 0;
  transform: translateY(-10px);
  transition: 0.125s ease-out all;
  background: white;
  border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-radius: 3px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  max-width: 1200px;
  padding: 10px;
  z-index: ${zIndexForeground + 1};
  &[data-enter] {
    opacity: 1;
    transform: translateY(0);
  }
`;
//# sourceMappingURL=styles.js.map